export default function accordionInit() {
	const personalOfferHeaders = document.querySelectorAll("[data-personalofferaccordion]");
	const moreInfo = 'mehr Infos';
	const lessInfo = 'weniger Infos';

	personalOfferHeaders.forEach(function(element) {
		element.addEventListener('click', function() {
			const icon = element.querySelector("[data-personaloffericon]");
			icon.classList.toggle("accordionIconRotate");

			if (element.getAttribute("data-select")
				&& (element.getAttribute("data-select") == 'innerBrand')
			) {
				const headline = element.querySelector("h3")
				if (icon.classList.contains('accordionIconRotate')) {
					headline.textContent = lessInfo;
				} else {
					headline.textContent = moreInfo;
				}
			}
		});
	});
}

accordionInit();
